const settings = {
    // Responsive breakpoints
    breakpoints: {
        small: 0,
        medium: 768,
        large: 960,
        extraLarge: 1200,
        largeWithMargins: 1344,
    },
};

const sortedBreakpoints = [];
let lastBreakpoint = null;
let currentBreakpoint = null;
const breakpointChangeCallbacks = [];

const updateWindowMetrics = () => {
    // Update the current responsive breakpoint
    lastBreakpoint = currentBreakpoint;
    for (let i = 0; i < sortedBreakpoints.length; i++) {
        const breakpoint = sortedBreakpoints[i];

        if (window.matchMedia('(min-width: ' + breakpoint + 'px)').matches) {
            currentBreakpoint = breakpoint;
            break;
        }
    }

    // Check if the breakpoint has changed
    if (lastBreakpoint !== currentBreakpoint && lastBreakpoint !== null) {
        for (const breakpointChangeCallback of breakpointChangeCallbacks) {
            // Determine if we're crossing the mobile-desktop threshold
            let mobileDesktopTransition = false;
            const lastBreakpointWasMobile = WindowMetrics.isMobile(
                lastBreakpoint,
                breakpointChangeCallback.finalMobileBreakpoint,
            );

            if (lastBreakpointWasMobile) {
                mobileDesktopTransition = !WindowMetrics.isMobile(
                    currentBreakpoint,
                    breakpointChangeCallback.finalMobileBreakpoint,
                );
            } else {
                mobileDesktopTransition = WindowMetrics.isMobile(
                    currentBreakpoint,
                    breakpointChangeCallback.finalMobileBreakpoint,
                );
            }

            // Execute breakpoint change callbacks
            for (let i = 0; i < breakpointChangeCallbacks.length; i++) {
                breakpointChangeCallbacks[i].callback(mobileDesktopTransition);
            }
        }
    }
};

// Initialize the sorted breakpoint array
for (const breakpointName in settings.breakpoints) {
    if (breakpointName) {
        sortedBreakpoints.push(settings.breakpoints[breakpointName]);
    }
}

sortedBreakpoints.sort((a, b) => {
    return b - a;
});

// Setup resize callback
window.addEventListener('resize', updateWindowMetrics);
updateWindowMetrics();

/** Encapsulates methods for determining the current responsive breakpoint */
export default class WindowMetrics {
    /**
     * Exposes the "settings.breakpoints" value for use in other modules
     * */
    static get breakpoints() {
        return settings.breakpoints;
    }

    /**
     * Exposes the "lastBreakpoint" value for use in other modules
     * */
    static get lastBreakpoint() {
        return lastBreakpoint;
    }

    /**
     * Exposes the "currentBreakpoint" value for use in other modules
     * */
    static get currentBreakpoint() {
        return currentBreakpoint;
    }

    /**
     * Determines if we're in a mobile breakpoint
     * @param {number} breakpointToTest A specific value to test (optional)
     * @param {number} finalMobileBreakpoint The largest breakpoint considered to be mobile
     * @return {boolean} Whether the current or specified breakpoint is
     *  considered to be a mobile breakpoint
     * */
    static isMobile(
        breakpointToTest,
        finalMobileBreakpoint = settings.breakpoints.small,
    ) {
        if (typeof breakpointToTest == 'number') {
            return breakpointToTest <= finalMobileBreakpoint;
        } else {
            return currentBreakpoint <= finalMobileBreakpoint;
        }
    }

    /**
     * Establishes a callback method to be called whenever a change
     * in the current breakpoint is detected
     * @param {Function} callback The callback to install
     * @param {number} finalMobileBreakpoint The largest breakpoint considered to be mobile
     * */
    static addBeakpointChangeCallback(
        callback,
        finalMobileBreakpoint = settings.breakpoints.small,
    ) {
        breakpointChangeCallbacks.push({
            callback: callback,
            finalMobileBreakpoint: finalMobileBreakpoint,
        });
    }
};
